import React from "react";
import { Select } from "antd";
import { CONSTANT } from "../../../config/Constant";

interface RecordPerPageProps {
  onChange: (params: any) => any;
  perPage: number;
  [key: string]: any;
}

/**
 * Renders a dropdown component for selecting the number of records per page for listing in AgGrid.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.onChange - The callback function to handle the change event.
 * @param {number} props.perPage - The current number of records per page.
 * @param {Object} props.rest - Additional props to be spread onto the Select component.
 * @return {JSX.Element} The rendered Select component.
 */
const RecordPerPage: React.FC<RecordPerPageProps> = ({onChange, perPage, ...rest}) => {
  return (
    <Select
      defaultValue={perPage + " per page"}
      style={{ width: "160px" }}
      onChange={onChange}
      {...rest}
    >
      {CONSTANT.PER_PAGE_RECORD.map((item: any) => {
        return (
          <Select.Option value={item.id} key={item.id}>
            {item.value}
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default RecordPerPage;
